export default "__VITE_PUBLIC_ASSET__ffca4bf0__"